export default {
	partner_id: '10122546588',
	partner_cp_type: '1001',
	baseURL: 'https://recharge.meizu.com',
	// staticURL: process.env.NODE_ENV === 'development' ? 'http://fe.meizu.com' : 'https://recharge-res.meizu.com/resources/recharge/mzcard'
	staticURL: process.env.NODE_ENV === 'development' ? 'https://cash.meizu.com' : 'https://ecash.mzres.com',
	pay_status: {
		64: '取出成功',
		40: '成功',
		30: '失败',
		2: '失败',
		1: '成功',
		0: '未知'
	},
	order_type: {
		10: '转入',
		20: '取出'
	},
	cp: '服务由广发银行提供',
	pay_channel_type: {
		0: "银行卡",
		2: "余额",
		4: "余额+",
		8: "红包",
	}
};



// WEBPACK FOOTER //
// ./src/config.js